require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./authors-sophie-baldwin.json") })
        }
      }, "path---authors-sophie-baldwin");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---authors-sophie-baldwin!./.cache/json/authors-sophie-baldwin.json
// module id = 1341
// module chunks = 231608221292675